/* CUSTOM:START VariantDeliveryMessaging */
class VariantDeliveryMessaging {
    static async init() {
        this.variantsData = {};
        this.selectedVariant = null;
        try {
            const liquidData = JSON.parse(
                document.getElementById('variant-delivery-messaging__variants_data').textContent
            );
            this.variantsData = liquidData.variants;
            this.selectedVariant = this.variantsData[liquidData.selected_or_first_available_variant] || null;
            document.addEventListener('on:variant:change', this.onVariantChange.bind(this));

            document.addEventListener('click', (e) => {
                const el = e.target.closest('[data-action="vdm-change-zip"]');
                if (!el) return;
                e.preventDefault();
                VariantDeliveryMessaging.promptForClientZip(); // static call; no `this` needed
            });
        } catch (e) {
            console.error(e);
        }
        await this.generateDeliveryMessaging();
    }

    static async onVariantChange(evt) {
        this.selectedVariant = evt.detail?.variant?.id;
        this.selectedVariant = this.variantsData[this.selectedVariant] || null;
        await this.generateDeliveryMessaging();
    }

    static async promptForClientZip() {
        const zip = prompt('Enter your zip code', localStorage.getItem('syl_user_zip') || '');
        if (zip !== null) {
            await this.updateClientZip(zip);
        }
    }

    static async updateClientZip(zip) {
        const usZipRegex = /^\d{5}(?:[-\s]\d{4})?$/;
        const caPostalRegex =
            /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ][ -]?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i;

        if (!usZipRegex.test(zip) && !caPostalRegex.test(zip)) {
            alert('Please enter a valid US ZIP or Canadian postal code');
            return;
        }

        if (window.localStorage.getItem('syl_user_zip') === zip) {
            return;
        }
        localStorage.setItem('syl_user_zip', zip);
        await this.generateDeliveryMessaging();
    }

    static async generateDeliveryMessaging() {
        const stockMessageEl = document.getElementById('variant-delivery-messaging__stock_message');
        const freeDeliveryMessageEl = document.getElementById('variant-delivery-messaging__free_delivery_message');
        try {
            if (stockMessageEl) {
                stockMessageEl.innerHTML = '';
            }
            if (freeDeliveryMessageEl) {
                freeDeliveryMessageEl.innerHTML = '';
            }
            // Reset CTA visibility on every (re)render; the blocked branch re-hides them.
            this.togglePurchaseCtas(false);
            this.selectedVariant.is_preorder = this.selectedVariant.available && this.selectedVariant.is_preorder;
            const debugCurrentDateTime = new URL(window.location.href).searchParams.get('debugCurrentDateTime');
            const now = debugCurrentDateTime ? new Date(debugCurrentDateTime) : new Date();
            let stockMessageHTML;
            let freeDeliveryMessageHTML = `Free ${this.selectedVariant.ships_freight ? 'Freight' : 'Standard'} Delivery${this.selectedVariant.price < 45 ? ' on orders over $45' : ''}`;

            if (this.selectedVariant.is_discontinued) {
                stockMessageHTML = 'This product is discontinued.';
            } else if (this.selectedVariant.available === false) {
                stockMessageHTML = 'This item is currently Out of Stock.';
                freeDeliveryMessageHTML = undefined;
            } else if (this.selectedVariant.is_preorder) {
                const preorderIconTpl = document.getElementById('variant-delivery-messaging__preorder-icon');
                const preorderIconHTML = preorderIconTpl ? preorderIconTpl.innerHTML : '';
                const restockDate = this.selectedVariant.est_restock_date
                    ? new Date(this.selectedVariant.est_restock_date)
                    : null;
                const isRestockDateInFuture = restockDate && restockDate > now;
                stockMessageHTML = `<span class="pre-order-indicator">${preorderIconHTML}Pre-Order</span>` + (
                    isRestockDateInFuture
                        ? `Shipping on ${restockDate.toLocaleDateString()} - Reserve Today!`
                        : 'Reserve today to ship out as soon as available!'
                );
            } else {
                try {
                    const response = await fetch('https://syl-shipping-offer-worker.sylvane-discountbandit7106.workers.dev', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            variantId: this.selectedVariant.id,
                            zip: window.localStorage.getItem('syl_user_zip') || undefined,
                            currentDateTime: debugCurrentDateTime
                                ? now.toISOString()
                                : undefined,
                        })
                    });
                    const responseData = await response.json();
                    if (!responseData.success) {
                        if (responseData.error === 'Provided zip is invalid' ||
                            responseData.error === 'Provided postal code is invalid') {
                            localStorage.removeItem('syl_user_zip');
                        }
                        throw new Error(responseData.error || 'Unknown Error');
                    }

                   const {
                        pickupDate,
                        transitDays,
                        zip: responseZip,
                        country,
                        isInternational,
                        isAkOrHi,
                        isDropship,
                        dshipLeadTime,
                        eligibility,
                    } = responseData.data;

                    if (responseZip && localStorage.getItem('syl_user_zip') !== responseZip) {
                        localStorage.setItem('syl_user_zip', responseZip);
                    }

                    if (eligibility?.status === 'blocked') {
                        const zip = localStorage.getItem('syl_user_zip');
                        const warningTitle = eligibility.title || 'Shipping restriction';

                        stockMessageHTML = `
                            <div class="shipping-warning">
                                <strong>${warningTitle}</strong><br> 
                                ${eligibility.reason}
                                <div class="shipping-warning__cta">
                                    <a href="#" data-action="vdm-change-zip">
                                        ${
                                            zip
                                                ? `Not shipping to <b>${zip}</b>? Click to update`
                                                : 'Enter ZIP code'
                                        }
                                    </a>
                                </div>
                            </div>
                        `;

                        if (stockMessageEl && stockMessageHTML) {
                            stockMessageEl.innerHTML = stockMessageHTML;
                        }
                        // Item can't ship here — remove the purchase CTAs.
                        this.togglePurchaseCtas(true);
                        return;
                    }

                    const isCanada = country === 'CA' || isInternational === true;
                    const isAkOrHiDestination = isAkOrHi === true;

                    if (isDropship) {
                        stockMessageHTML = `<span class="in-stock-indicator">In Stock</span>`;
                        const lt = dshipLeadTime || 0;
                        if (lt >= 49) {
                            stockMessageHTML += `<strong> Usually ships in 12 weeks.</strong>`;
                        } else if (lt >= 21) {
                            stockMessageHTML += `<strong> Usually ships in 4 to 6 weeks.</strong>`;
                        } else if (lt >= 20) {
                            stockMessageHTML += `<strong> Usually ships in a month.</strong>`;
                        } else if (lt >= 15) {
                            stockMessageHTML += `<strong> Usually ships in 2 to 3 weeks.</strong>`;
                        } else if (lt >= 10) {
                            stockMessageHTML += `<strong> Usually ships in 2 weeks.</strong>`;
                        } else if (lt >= 6) {
                            stockMessageHTML += `Usually ships in a week.`;
                        } else if (lt >= 4) {
                            stockMessageHTML += `Usually ships in 3 to 5 business days.`;
                        } else if (lt >= 3) {
                            stockMessageHTML += `Usually ships in 2 to 3 business days.`;
                        } else if (lt >= 2) {
                            stockMessageHTML += `Usually ships in 1 to 2 business days.`;
                        } else {
                            stockMessageHTML += `Usually ships in 24 hours.`;
                        }
                    } else {
                        const target = new Date(pickupDate);
                        const transitDaysNum = typeof transitDays === 'number' ? transitDays : null;

                        const isToday = target.toLocaleDateString() === now.toLocaleDateString();

                        const diffMs = target - now;

                        if (isToday && diffMs > 0) {
                            stockMessageHTML = `Order today, ships today from our US warehouse.`;
                        } else {
                            const dateDisplay = target.toLocaleDateString(undefined, {
                                weekday: 'long',
                                month: 'long',
                                day: 'numeric',
                            });
                            stockMessageHTML =
                                `<span class="in-stock-indicator">In Stock</span>` +
                                `Order now! Ships on <strong>${dateDisplay}</strong>.`;
                        }
                    }

                    if (isCanada) {
                        freeDeliveryMessageHTML =
                            `Shipping, taxes, duties and fees calculated in checkout`;
                    } else if (isAkOrHiDestination) {
                        freeDeliveryMessageHTML =
                            `Shipping, taxes, duties and fees calculated in checkout`;
                    } else if (!isDropship && !this.selectedVariant.ships_freight) {
                        const transitDaysNum = typeof transitDays === 'number' ? transitDays : null;
                        if (transitDaysNum !== null && transitDaysNum <= 3) {
                            const dayText =
                                transitDaysNum === 1 ? 'Next' :
                                transitDaysNum === 2 ? '2' :
                                '3';
                            freeDeliveryMessageHTML =
                                `Free ${dayText} Day Delivery` +
                                `${this.selectedVariant.price < 45 ? ' on orders over $45' : ''}`;
                        }
                    }
                } catch (e) {
                    console.error('[variant-delivery-messaging] Error: %o', e);
                }
            }

            if (stockMessageEl && stockMessageHTML) {
                stockMessageEl.innerHTML = stockMessageHTML;
            }

            if (freeDeliveryMessageEl && freeDeliveryMessageHTML) {
                freeDeliveryMessageEl.innerHTML = freeDeliveryMessageHTML;
                const zip = localStorage.getItem('syl_user_zip');
                if (zip) {
                    freeDeliveryMessageEl.innerHTML += ` to <span data-action="vdm-change-zip">${zip}</span>`;
                }
            }
        } catch (e) {
            console.error('[variant-delivery-messaging] Error: %o', e);
        }
    }

    // Show/hide the purchase CTAs (qty + add-to-cart, Affirm messaging,
    // extended-warranty offering) within this product's info block. Called
    // with `true` when a shipping exclusion is shown, `false` to restore.
    static togglePurchaseCtas(hide) {
        const root = document
            .getElementById('variant-delivery-messaging')
            ?.closest('.product-info');
        if (!root) return;

        const selectors = [
            '.product-info__add-to-cart',              // quantity input + add-to-cart button
            '.product-inventory',                      // "X in stock / Act fast" inventory notice
            '#sb-prod-element',                        // SureBright extended warranty
            '[id*="affirm_pay_over_time_messaging"]',  // Affirm pay-over-time messaging
        ];

        selectors.forEach((selector) => {
            root.querySelectorAll(selector).forEach((el) => {
                // For Affirm, hide the whole product-info block so no empty gap remains.
                const target = selector.indexOf('affirm') !== -1
                    ? (el.closest('.product-info__block') || el)
                    : el;
                target.classList.toggle('vdm-cta-hidden', hide);
            });
        });
    }
}

await VariantDeliveryMessaging.init();
/* CUSTOM:END VariantDeliveryMessaging */